import { render, staticRenderFns } from "./Newgamesboxbody.vue?vue&type=template&id=d2c030f8&scoped=true&"
import script from "./Newgamesboxbody.vue?vue&type=script&lang=js&"
export * from "./Newgamesboxbody.vue?vue&type=script&lang=js&"
import style0 from "./Newgamesboxbody.vue?vue&type=style&index=0&id=d2c030f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c030f8",
  null
  
)

export default component.exports